<template>
    <div class="container">
        <div class="title">智能公寓数据驾驶舱
            <div class="date">
                <i class="el-icon-date"></i>
                <span>{{ today }}</span>
            </div>
        </div>
        <div class="main">
            <div class="left">
                <div class="lone">
                    <div class="card">
                        <div class="weyongl">
                            <div class="cardtitle">水电用量情况</div>
                            <div class="timetype"><span :class="zhexianstatus == 'month' ? 'xuanzhong': ''" @click="togglewhite('month')">月</span><span :class="zhexianstatus == 'day' ? 'xuanzhong': ''" @click="togglewhite('day')">天</span></div>
                        </div>
                        <div id="zhexian" style="width: 27.5rem; height: 13.125rem;"></div>
                    </div>
                </div>
                <div class="ltwo">
                    <div class="card">
                        <div class="cardtitle">业务处理情况</div>
                        <div class="fourhuan">
                            <div id="yewu1" style="width: 12rem; height: 8rem;"></div>
                            <div id="yewu2" style="width: 12rem; height: 8rem;"></div>
                            <div id="yewu3" style="width: 12rem; height: 8rem;"></div>
                            <div id="yewu4" style="width: 12rem; height: 8rem;"></div>
                        </div>
                    </div>
                </div>
                <div class="lthree">
                    <div class="card">
                        <div class="cardtitle">智能设备</div>
                        <div style="padding: 10px 20px">
                            <table>
                                <tr class="tablehui">
                                    <th>设备类型</th>
                                    <th>设备总数</th>
                                    <th>正常/异常</th>
                                    <th>通/断</th>
                                </tr>
                                <tr>
                                    <td>智能水表</td>
                                    <td>{{ smart.water.total }}</td>
                                    <td>{{ smart.water.normal }}/<span style="color: red;">{{ smart.water.exception
                                            }}</span></td>
                                    <td>{{ smart.water.through }}/<span style="color: red;">{{ smart.water.break
                                            }}</span></td>
                                </tr>
                                <tr class="tablehui">
                                    <td>智能电表</td>
                                    <td>{{ smart.elect.total }}</td>
                                    <td>{{ smart.elect.normal }}/<span style="color: red;">{{ smart.elect.exception
                                            }}</span></td>
                                    <td>{{ smart.elect.through }}/<span style="color: red;">{{ smart.elect.break
                                            }}</span></td>
                                </tr>
                                <tr>
                                    <td>智能门锁</td>
                                    <td>{{ smart.lock.total }}</td>
                                    <td>{{ smart.lock.normal }}/<span style="color: red;">{{ smart.lock.exception
                                            }}</span></td>
                                    <td>{{ smart.lock.through }}/<span style="color: red;">{{ smart.lock.break }}</span>
                                    </td>
                                </tr>
                                <tr class="tablehui">
                                    <td>大门门禁</td>
                                    <td>{{ smart.gate.total }}</td>
                                    <td>{{ smart.gate.normal }}/<span style="color: red;">{{ smart.gate.exception
                                            }}</span></td>
                                    <td>{{ smart.gate.through }}/<span style="color: red;">{{ smart.gate.break }}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="center">
                <div class="tone">
                    <div class="card">
                        <div class="cardtitle">房源数据</div>
                        <div class="list">
                            <div class="item">
                                <div class="top">{{ house.total }} <span class="hei">间</span></div>
                                <div class="bottom">房源总数</div>
                            </div>
                            <div class="item">
                                <div class="top">{{ house.renting }} <span class="hei">间</span></div>
                                <div class="bottom">已出租数</div>
                            </div>
                            <div class="item">
                                <div class="top">{{ house.empty }} <span class="hei">间</span></div>
                                <div class="bottom">空置数</div>
                            </div>
                            <div class="item">
                                <div class="top">{{ house.release }} <span class="hei">间</span></div>
                                <div class="bottom">发布数</div>
                            </div>
                            <div class="item">
                                <div class="top">{{ house.ratio }} <span class="hei">%</span></div>
                                <div class="bottom">出租率</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tworow">
                    <div class="card">
                        <div class="cardtitle">租客数据</div>
                        <div class="list">
                            <div class="item">
                                <div class="top">{{ tenant.total }} <span class="hei">人</span></div>
                                <div class="bottom">租客总数</div>
                            </div>
                            <div class="item">
                                <div class="top">{{ tenant.renting }} <span class="hei">人</span></div>
                                <div class="bottom">在租数</div>
                            </div>
                            <div class="item">
                                <div class="top">{{ tenant.cohabit }} <span class="hei">人</span></div>
                                <div class="bottom">同住人数</div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="cardtitle">合同数据</div>
                        <div class="list">
                            <div class="item">
                                <div class="top">{{ contract.total }} <span class="hei">份</span></div>
                                <div class="bottom">合同总数</div>
                            </div>
                            <div class="item">
                                <div class="top">{{ contract.valid }} <span class="hei">人</span></div>
                                <div class="bottom">有效合同数</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="three">
                    <div class="card">
                        <div class="cardtitle">财务数据情况</div>
                        <div class="juzhong">
                            <div>
                                <div id="caiwu" :style="style"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="four">
                    <div class="card">
                        <div class="cardtitle">财务数据年度累计(元)</div>
                        <div style="padding: 10px 20px">
                            <table>
                                <tr class="tablehui">
                                    <th>费用类型</th>
                                    <th>年度累计</th>
                                    <th>微信支付</th>
                                    <th>后台支付</th>
                                    <th>待支付</th>
                                </tr>
                                <tr>
                                    <td>租金</td>
                                    <td>{{ financeYear.rent.total }} </td>
                                    <td>{{ financeYear.rent.wechat }}</td>
                                    <td>{{ financeYear.rent.admin }} </td>
                                    <td>{{ financeYear.rent.nopay }} </td>
                                </tr>
                                <tr class="tablehui">
                                    <td>水费</td>
                                    <td>{{ financeYear.water.total }} </td>
                                    <td>{{ financeYear.water.wechat }}</td>
                                    <td>{{ financeYear.water.admin }} </td>
                                    <td>{{ financeYear.water.nopay }} </td>
                                </tr>
                                <tr>
                                    <td>电费</td>
                                    <td>{{ financeYear.electricity.total }} </td>
                                    <td>{{ financeYear.electricity.wechat }}</td>
                                    <td>{{ financeYear.electricity.admin }} </td>
                                    <td>{{ financeYear.electricity.nopay }} </td>
                                </tr>
                                <tr class="tablehui">
                                    <td>违约金</td>
                                    <td>{{ financeYear.penalty.total }} </td>
                                    <td>{{ financeYear.penalty.wechat }}</td>
                                    <td>{{ financeYear.penalty.admin }} </td>
                                    <td>{{ financeYear.penalty.nopay }} </td>
                                </tr>
                                <tr>
                                    <td>其他费用</td>
                                    <td>{{ financeYear.other.total }} </td>
                                    <td>{{ financeYear.other.wechat }}</td>
                                    <td>{{ financeYear.other.admin }} </td>
                                    <td>{{ financeYear.other.nopay }} </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <div class="right">
                <div class="rone">
                    <div class="card">
                        <div class="cardtitle">用户申请</div>
                        <div style="padding: 10px 20px;max-height: 11.6rem; overflow-y: auto;">
                            <table>
                                <tr class="tablehui">
                                    <th>房间号</th>
                                    <th>申请类别</th>
                                    <th>申请时间</th>
                                    <th>操作</th>
                                </tr>

                                <tr v-for="(item, index) in application" :key="index"
                                    :class="(index + 2) % 2 == 1 ? 'tablehui' : ''">
                                    <td>{{ item.room_num }}</td>
                                    <td>{{ item.type }}</td>
                                    <td>{{ item.time }}</td>
                                    <td><span style="color:blue;">详情</span></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="rtwo">
                    <div class="card">
                        <div class="cardtitle">合同到期预警</div>
                        <div style="padding: 10px 20px;max-height: 11.6rem; overflow-y: auto;">
                            <table>
                                <tr class="tablehui">
                                    <th>房间号</th>
                                    <th>剩余天数</th>
                                    <th>到期时间</th>
                                    <th>是否忽略</th>
                                    <th>操作</th>
                                </tr>
                                <tr v-for="(item, index) in contractEnd" :key="index"
                                    :class="(index + 2) % 2 == 1 ? 'tablehui' : ''">
                                    <td>{{ item.room_num }}</td>
                                    <td><span style="color:red;">{{ item.day }}</span></td>
                                    <td>{{ item.time }}</td>
                                    <td><span style="color:blue;">忽略</span></td>
                                    <td><span style="color:blue;">详情</span></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="rthree">
                    <div class="card">
                        <div class="cardtitle">水电超量预警(本月)</div>
                        <div style="padding: 10px 20px;max-height: 11.6rem; overflow-y: auto;">
                            <table>
                                <tr class="tablehui">
                                    <th>房间号</th>
                                    <th>房间状态</th>
                                    <th>预警时间</th>
                                    <th>类别</th>
                                    <th>是否忽略</th>
                                </tr>
                                <tr v-for="(item, index) in yujing" :key="index"
                                    :class="(index + 2) % 2 == 1 ? 'tablehui' : ''">
                                    <td>{{ item.room_num }}</td>
                                    <td><span style="color:red;">{{ item.status }}</span></td>
                                    <td>{{ item.create_time }}</td>
                                    <td><span style="color:blue">{{ item.type }}</span></td>
                                    <td><span style="color:blue">详情</span></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import * as echarts from 'echarts';
import { new_index_data, contract_endtime, index_meters_data } from '../../api/api.js'
export default {
    data() {
        return {
            today: '',
            style: 'width: 31.25rem;height:12.5rem;',
            house: {},
            tenant: {},
            contract: {},
            finance: {},
            financeYear: {
                rent: {},
                water: {},
                electricity: {},
                penalty: {},
                other: {},
            },
            smart: {
                water: {},
                elect: {},
                lock: {},
                gate: {},
            },
            application: [],
            yujing: [],
            contractEnd: [],
            day: {
                water: [],
                elect: []
            },
            month: {
                water: [],
                elect: [],
            },
            zhexianstatus: 'month'
        }
    },
    methods: {
        getTime() {
            var d = new Date();
            var y = d.getFullYear();
            var m = d.getMonth();
            var dd = d.getDate();
            var h = d.getHours();
            var i = d.getMinutes();
            var s = d.getSeconds();
            var w = d.getDay();
            if (s < 10) {
                s = "0" + s;
            }
            if (i < 10) {
                i = "0" + i;
            }
            m = m + 1;
            var week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
            this.today = y + '年' + m + '月' + dd + '日' + ' ' + h + ':' + i + ':' + s + ' ' + week[w];
        },
        caiwubaobiao(array) {
            var chartDom = document.getElementById('caiwu');
            var myChart = echarts.init(chartDom);
            var option;
            //数组处理
            var source = [['product', '累计', '房租', '水电']];
            var i = 1;
            array.forEach(element => {
                source.push([this.monthaddsub(i), element.total, element.rent, element.ew]);
                i += 1;
            });
            option = {
                legend: {},
                tooltip: {},
                dataset: {
                    source: source
                },
                xAxis: { type: 'category' },
                yAxis: {},
                series: [{ type: 'bar' }, { type: 'bar' }, { type: 'bar' }]
            };

            option && myChart.setOption(option);
        },
        yewuchuli1(data) {
            var chartDom = document.getElementById('yewu1');
            var myChart = echarts.init(chartDom);
            var option;

            option = {
                title: {
                    text: '报修数' + data.total,
                    left: 'center',
                    top: 'center',
                    textStyle: {
                        fontSize: 10,
                    }
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '80%'],
                        label: {
                            show: false,
                            position: 'center'
                        },
                        data: [
                            { value: data.no, name: '未报修数', itemStyle: { color: '#ee822f' } },
                            { value: data.yes, name: '已报修数', itemStyle: { color: '#4874cb' } }
                        ]
                    }
                ]
            };

            option && myChart.setOption(option);
        },
        yewuchuli2(data) {
            var chartDom = document.getElementById('yewu2');
            var myChart = echarts.init(chartDom);
            var option;

            option = {
                title: {
                    text: '看房数' + data.total,
                    left: 'center',
                    top: 'center',
                    textStyle: {
                        fontSize: 10,
                    }
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '80%'],
                        label: {
                            show: false,
                            position: 'center'
                        },
                        data: [
                            { value: data.no, name: '未看房数', itemStyle: { color: '#ee822f' } },
                            { value: data.yes, name: '已看房数', itemStyle: { color: '#4874cb' } },
                        ]
                    }
                ]
            };

            option && myChart.setOption(option);
        },
        yewuchuli3(data) {
            var chartDom = document.getElementById('yewu3');
            var myChart = echarts.init(chartDom);
            var option;

            option = {
                title: {
                    text: '续租数' + data.total,
                    left: 'center',
                    top: 'center',
                    textStyle: {
                        fontSize: 10,
                    }
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '80%'],
                        label: {
                            show: false,
                            position: 'center'
                        },
                        data: [
                            { value: data.no, name: '未续租数', itemStyle: { color: '#ee822f' } },
                            { value: data.yes, name: '已续租数', itemStyle: { color: '#4874cb' } },
                        ]
                    }
                ]
            };

            option && myChart.setOption(option);
        },
        yewuchuli4(data) {
            var chartDom = document.getElementById('yewu4');
            var myChart = echarts.init(chartDom);
            var option;

            option = {
                title: {
                    text: '退租数' + data.total,
                    left: 'center',
                    top: 'center',
                    textStyle: {
                        fontSize: 10,
                    }
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '80%'],
                        label: {
                            show: false,
                            position: 'center'
                        },
                        data: [
                            { value: data.no, name: '未报修数', itemStyle: { color: '#ee822f' } },
                            { value: data.yes, name: '已报修数', itemStyle: { color: '#4874cb' } },
                        ]
                    }
                ]
            };

            option && myChart.setOption(option);
        },
        weyongliang(data) {
            var chartDom = document.getElementById('zhexian');
            var myChart = echarts.init(chartDom);
            var option;

            option = {
                xAxis: {
                    type: 'category',
                    data: [this.monthaddsub(1) + '月', this.monthaddsub(2) + '月', this.monthaddsub(3) + '月', this.monthaddsub(4) + '月', this.monthaddsub(5) + '月', this.monthaddsub(6) + '月']
                },
                yAxis: [
                    {
                        type: 'value',
                        name: '水(吨)',
                    },
                    {
                        type: 'value',
                        name: '电(度)',
                    },
                ],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        animation: false,
                        label: {
                            backgroundColor: '#505765'
                        }
                    }
                },
                series: [
                    {
                        data: data.water,
                        type: 'line',
                        name: '水(吨)',
                        yAxisIndex: 0,
                    },
                    {
                        data: data.elect,
                        type: 'line',
                        name: '电',
                        yAxisIndex: 1,
                    },

                ]
            };

            option && myChart.setOption(option);

        },
        //获取首页主要数据
        getIndexData() {
            new_index_data().then(res => {
                if (res.status == 200) {
                    this.house = res.data.house
                    this.tenant = res.data.tenant
                    this.contract = res.data.contract
                    this.finance = res.data.finance
                    this.financeYear = res.data.finance_year
                    this.smart = res.data.smart
                    this.application = res.data.application
                    this.yujing = res.data.yujing
                    this.caiwubaobiao(res.data.finance);
                    this.yewuchuli1(res.data.business.repair);
                    this.yewuchuli2(res.data.business.kanfang);
                    this.yewuchuli3(res.data.business.relet);
                    this.yewuchuli4(res.data.business.outrent);
                    // this.business = res.data.business
                }
            }).catch(err => {
                console.log(err)
            })
        },
        monthaddsub(month) {
            var date = new Date;
            var time = date.setMonth(date.getMonth() - month);
            var newDate = new Date(time);
            var newMonth = newDate.getMonth();
            return (newMonth + 1);
        },
        //获取临期合同
        getContractend() {
            contract_endtime().then(res => {
                if (res.status == 200) {
                    this.contractEnd = res.data;
                }
            }).catch(err => {
                console.log(err)
            })
        },
        //获取首页水电数据
        getIndexMeters() {
            index_meters_data().then(res => {
                if (res.status == 200) {
                    this.weyongliang(res.data.month);
                    this.day = res.data.day;
                    this.month = res.data.month;
                }
            }).catch(err => {
                console.log(err)
            })
        },
        //月天数据切换
        togglewhite(de){
            if(de == 'month'){
                this.zhexianstatus = 'month';
                this.weyongliang(this.month);
            }else{
                this.zhexianstatus = 'day';
                this.weyongliang(this.day);
            }
        }
    },
    mounted() {
        setInterval(this.getTime, 1000);
        this.getIndexData();
        this.getContractend();
        this.getIndexMeters();
    }
}
</script>

<style scoped>
.container {
    background-color: #f2f2f2;
}

.title {
    background-color: #1d46ad;
    color: #fff;
    text-align: center;
    margin-top: 5px;
    height: 55px;
    line-height: 55px;
    font-size: 28px;
    position: relative;
}

.date {
    position: absolute;
    right: 66px;
    top: 0px;
    font-size: 16px;
    display: flex;
    justify-content: center;
    justify-items: center;
}

.el-icon-date {
    margin-right: 20px;
    font-size: 32px;
    line-height: 55px;
}

.main {
    display: flex;
    margin-top: 10px;
}

.left {
    /* background-color: #ff002a; */
    flex: 6;
    margin-left: 7px;
}

.center {
    /* background-color: blue; */
    flex: 10;
    margin-left: 7px;
}

.right {
    /* background-color: #000; */
    flex: 6;
    margin-left: 7px;
    margin-right: 7px;
}

.card {
    background-color: #fff;
    border-radius: 8px;
    width: 100%;
    height: 100%;
    border: 1px solid #fff;
}

.cardtitle {
    font-size: 16px;
    font-weight: 700;
    margin-left: 10px;
    margin-top: 5px;
}

.top {
    color: #3546ad;
    font-size: 26px;
}

.hei {
    color: #000;
    font-size: 16px;
}

.bottom {
    font-size: 14px;
    margin-top: 10px;
    text-align: center;
    margin-bottom: 10px;
}

.list {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
}

.tworow {
    display: flex;
    justify-content: space-around;
    margin-top: 12px;
}

.tworow>div:nth-child(1) {
    flex: 10;
    margin-right: 12px;
}

.tworow>div:nth-child(2) {
    flex: 6;
}

.three {
    margin-top: 12px;
    height: 13.6rem;
}

.juzhong {
    display: flex;
    justify-content: center;
}

.four {
    margin-top: 20px;
    height: 13.8rem;
}

.four table {
    width: 100%;
    text-align: center;
    font-size: 16px;
    border: 1px solid #e7e6e6;
}

.four table td {
    font-weight: 400;
    font-size: 14px;
}

.tablehui {
    background-color: #e7e6e6;
}

table {
    width: 100%;
    text-align: center;
}

th {
    font-size: 16px;
    font-weight: 700;
}

td {
    font-size: 14px;
    font-weight: 400;
}

.right,
.left {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.rtwo,
.rthree,
.ltwo,
.lthree {
    margin-top: 12px;
}

.rtwo,
.rthree,
.rone {
    height: 14rem;
}

.lone {
    height: 14rem;
}

.ltwo {
    height: 18rem;
}

.lthree {
    height: 10rem;
}

.fourhuan {
    display: flex;
    flex-wrap: wrap;
}

.timetype {
    background-color: #e7e6e6;
    margin-top: 5px;
    width: 5rem;
    height: 2rem;
    line-height: 1rem;
    text-align: center;
    margin-left: 15rem;
    font-size: 16px;
    border-radius: 10px;
    padding: 5px;
}

.timetype span {
    display: inline-block;
    width: 50%;
    height: 100%;
    line-height: 26px;
    border-radius: 5px;
}

.xuanzhong {
    background-color: #fff;
}

.weyongl {
    display: flex;
}
</style>